// extracted by mini-css-extract-plugin
export default {"table":"Orders_table__ceHtE","icons":"Orders_icons__5K+GB","pending":"Orders_pending__pMlF0","delivered":"Orders_delivered__5Z0QP"};